// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__r6-vX","content":"styles_content__uideN","projects":"styles_projects__ec4Ga"};